import type { Room } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { useHotelApplicationDataQuery } from "@/components/features/_shared/repository/hotel-application-data/query";

import { RoomList_ListPage_Query } from "./query";
import { useDeleteRoom } from "./use-delete-room";

type Props = {
	hotelID: string;
};

export const useRoomList = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(RoomList_ListPage_Query, {
		variables: { hotelID },
		fetchPolicy: "network-only",
	});

	const rooms: Room[] =
		data?.roomList.rooms.map((item) => {
			const { __typename, ...room } = item;

			return { ...room };
		}) ?? [];

	const dummies =
		data?.roomList.dummy.map((item) => {
			const { __typename, ...dummy } = item;

			return { ...dummy };
		}) ?? [];

	const { onDeleteRoom } = useDeleteRoom();
	const handleRoomDeleteItems = {
		handleRoomDelete: (roomID: string) => {
			onDeleteRoom({ hotelID, roomID });
		},
	};

	const { hotelApplicationData } = useHotelApplicationDataQuery(hotelID);

	return {
		rooms,
		dummies,
		handleRoomDeleteItems,
		inUseBasic: hotelApplicationData?.hotelApplicationStatus.inUseBasic ?? false,
	};
};
